"use client";

import { useEffect } from "react";
import { registerServiceWorker } from "./registerSW";
import { attachResubscribeListener } from "./pushClient";
import { PushPermissionBanner } from "@/components/feature/notifications/PushPermissionBanner";

/**
 * Mount-once client component that registers the Service Worker, listens for
 * transparent re-subscribe signals from the SW (iOS recovery), and renders
 * the dezent push-permission banner.
 */
export function PwaBootstrap() {
  useEffect(() => {
    void registerServiceWorker();
    const detach = attachResubscribeListener();
    return detach;
  }, []);
  return <PushPermissionBanner />;
}
